import { FDCQuickLinks } from '../../../cimsPage/instances/fdc'
import { QuickLinks } from '../../common'

const quickLinks = QuickLinks({
  page: FDCQuickLinks,
  create: '28c149cb-2564-435f-b2a5-df03bda2806d',
  view: '1e4b155a-4310-4c6c-b8b6-5e2fe90b39ce',
  edit: '23dd887f-b5b7-48ca-9886-0c44fea4d2c3',
  removeRestore: '2b7c9b0b-8c06-48ee-aaed-2c3301501d69',
})

export const CreateFDCQuickLink = quickLinks.Create
export const ViewFDCQuickLink = quickLinks.View
export const EditFDCQuickLink = quickLinks.Edit
export const RemoveRestoreFDCQuickLink = quickLinks.RemoveRestore

export type FDCQuickLinkPermission =
  | typeof CreateFDCQuickLink
  | typeof ViewFDCQuickLink
  | typeof EditFDCQuickLink
  | typeof RemoveRestoreFDCQuickLink
